import { em } from 'polished'
import PropTypes from 'prop-types'
import React from 'react'
import { css } from 'styled-components'

import { Col, Row } from 'styles/components/layout'
import { CartItemTitle } from 'styles/components/typography'

import {
  TextBlock,
  Wrapper,
  DynamicImageStyled,
  TextLHStyled,
  ColCentered,
  ButtonContent,
  TextLHWithOpacity,
  ButtonRoundedStStyled,
} from './styles'

const CartAddItem = ({
  boxes,
  title,
  description,
  buttonText,
  buttonSize,
  addItem,
  isZeroPrice,
  buttonTextOutOffStock,
}) => {
  return (
    <Wrapper>
      <Row flexWrap={{ md: 'nowrap' }}>
        <Col width={{ xs: em(78), md: em(123), lg: em(192) }}>
          <DynamicImageStyled
            image={boxes}
            imageSizes={{ xs: 58, md: 103 }}
            imageType="png"
            alt=""
          />
        </Col>
        <TextBlock
          width={{ xs: `calc(100% - ${em(78)})`, md: 'initial' }}
          flexGrow={{ md: 1 }}
        >
          <CartItemTitle dangerouslySetInnerHTML={{ __html: title }} />
          <TextLHWithOpacity
            dangerouslySetInnerHTML={{ __html: description }}
          />
        </TextBlock>
        <ColCentered width={{ md: em(isZeroPrice ? 250 : 168) }} ml={{ xs: em(78), md: 0 }}>
          <ButtonRoundedStStyled
            forwardedAs="button"
            size={buttonSize}
            bgStyles={css`
              background-color: ${p => p.theme.colors.white};
              box-shadow: 0px 6px 10px ${p => p.theme.colors.blackOp05};

              ${p => p.theme.mq.upMd} {
                box-shadow: 0px ${em(5)} ${em(12)}
                  ${p => p.theme.colors.blackOp05};
              }
            `}
            blackoutStyles={css`
              background-color: ${p => p.theme.colors.white};
              box-shadow: 0px ${em(5)} ${em(12)} ${p => p.theme.colors.blackOp2};
            `}
            textStyles={css`
              color: ${p => p.theme.colors.black};
            `}
            isDisabled={isZeroPrice}
            onClick={addItem}
          >
            <ButtonContent>
              <TextLHStyled dangerouslySetInnerHTML={{ __html: isZeroPrice ? buttonTextOutOffStock : buttonText }} />
            </ButtonContent>
          </ButtonRoundedStStyled>
        </ColCentered>
      </Row>
    </Wrapper>
  )
}

CartAddItem.propTypes = {
  boxes: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  buttonText: PropTypes.string.isRequired,
  buttonSize: PropTypes.string.isRequired,
  addItem: PropTypes.func.isRequired,
  isZeroPrice: PropTypes.bool,
  buttonTextOutOffStock: PropTypes.string,
}

export default React.memo(CartAddItem)
